import React, { ReactElement } from 'react';
import { LegendItemContainer } from './legendItem';
import { LegendModel } from './legend.model';
import { LegendStyled } from './legend.styled';

export const LegendContainer = ({ data }: LegendModel): ReactElement => (
  <LegendStyled>{data.map(LegendItemContainer)}</LegendStyled>
);
